var CONFUSEDWEBSITE = CONFUSEDWEBSITE || {};

    (function ($, ctx, google) {
    /**
       * setup Google custom search
       *
       * @param {object} searchDetails the search details required for custom search
       * @param {string} searchDetails.searchFormId the ID of the search form element
       * @param {string} searchDetails.buttonClass a class of the search button element
       * @param {string} searchDetails.searchTextId the ID of the search text box element
       * @param {string} searchDetails.customSearchKeyId the ID of the custom search key element
   **/ 
        CONFUSEDWEBSITE.setupSearch = function (searchDetails) {
            var $search = $('#' + searchDetails.searchFormId),
            $button = $('.' + searchDetails.buttonClass, $search),
            $searchTextBox = $('#' + searchDetails.searchTextId, $search),
            autoCompletionOptions = {
                'maxCompletions': 5,
                'styleOptions': {
                    'xOffset': 10
                }
            };

        function redirectToResultsPage() {
            var action = $search.data('action'),
                args = [],
                query;

            query = $search.find('input[name="query"]').val();
            if (query === '')
            {
                // don't think these will error because jQuery NEVER errors ;-)
                $(searchDetails.invalidInputSelector).show();
                return;
            }

            $(searchDetails.invalidInputSelector).hide();

            $.each(['cx', 'ie', 'sa', 'query'], function (index, value) {
                    args.push(value + '=' + encodeURIComponent($search.find('input[name="' + value + '"]').val()));
                });
            ctx.location.href = action + '?' + args.join('&');
        }

        if (!google) {
            console.log('!google');
            return;
        }

        function setupSearchAutocomplete() {
            google.search.CustomSearchControl.attachAutoCompletionWithOptions(
                $('#' + searchDetails.customSearchKeyId).val(),
                $('#' + searchDetails.searchTextId)[0],
                { 'submit': redirectToResultsPage },
                autoCompletionOptions);
        }

        if (google.search === undefined || google.search.CustomSearchControl === undefined) {
            google.setOnLoadCallback(function () {
                setupSearchAutocomplete();
            });
        } else {
            setupSearchAutocomplete();
        }

        $(searchDetails.invalidInputSelector).hide();
        $button.on('click', function () {
                redirectToResultsPage();
                return false;
            });

        $searchTextBox.on('keyup', function (event) {
                if (event.which === 13) { // If user presses the enter key
                    redirectToResultsPage();
                }
                return false;
            });
    };


    /*
       * setup Google custom search results
       *
       * @param {object} searchResultConfiguration the search details required for custom search
       * @param {string} searchResultConfiguration.noResultsH2Selector the selector to grab the no results h2 element
       * @param {string} searchResultConfiguration.resultsH2Selector the selector to grab the results h2 element
       * @param {string} searchResultConfiguration.resultsSetSize the number of results to display per page
       * @param {string} searchResultConfiguration.customSearchKey the ID of the custom search key element       
       * @param {string} searchResultConfiguration.queryParameter the name of the query parameter to use
    */
    CONFUSEDWEBSITE.setupSearchResult = function (searchResultConfiguration) {

        function searchCompleteCallback(control, searcher) {
            // Show our pre-configured search results message if there are no results. Google's one will be hidden using css
            if (typeof (searcher) === 'undefined' || typeof (searcher.results) === 'undefined' || searcher.results.length === 0) {
                $(searchResultConfiguration.noResultsH2Selector).css('display', '');
                $(searchResultConfiguration.resultsH2Selector).css('display', 'none');
            } 
        }

        function setupSearchResultsCallback() {
            var customSearchOptions = {};
            var query = '';

            //https://developers.google.com/custom-search/docs/js/cselement-reference#cse-el
            var customSearchControl = new google.search.CustomSearchControl(searchResultConfiguration.customSearchKey, customSearchOptions);

            if (searchResultConfiguration.resultsSetSize) {
                customSearchControl.setResultSetSize(searchResultConfiguration.resultsSetSize);
            } else {
                customSearchControl.setResultSetSize(google.search.Search.FILTERED_CSE_RESULTSET);
            }

            //customSearchControl.setNoResultsString('No results found.'); // This doesn't seem to work, so it's been removed.
            customSearchControl.setLinkTarget(google.search.Search.LINK_TARGET_SELF);

            //the null here can be used we *think* to add in a 'this' context, but we don't need it, so don't pass anything in :-)
            customSearchControl.setSearchCompleteCallback(null, searchCompleteCallback);

            /*  Configure options - found documentation below for this...
                https://developers.google.com/custom-search/docs/js/cselement-reference#csedrawoptions-el
            */
            var options = new google.search.DrawOptions();
            options.setAutoComplete(true);
            options.enableSearchResultsOnly();

            customSearchControl.draw($(searchResultConfiguration.resultsSelector)[0].id, options);

            query = CONFUSEDWEBSITE.getUrlVars();
            var queryValue = query[searchResultConfiguration.queryParameter];
            if (queryValue !== undefined) {
                customSearchControl.execute(decodeURIComponent(queryValue).replace(/\+/g, ' '));
            }
        }

        // do some type checking here first, no point doing this if we're not setup properly
        if (!google) {
            return;
        }

        if (searchResultConfiguration.customSearchKey === undefined) {
            return;
        }

        if (!searchResultConfiguration.resultsSelector || !$(searchResultConfiguration.resultsSelector)) {
            return;
        }

        if (google.search === undefined || google.search.CustomSearchControl === undefined) {
            google.setOnLoadCallback(function () {
                setupSearchResultsCallback();
            }, true);
        } else {
            setupSearchResultsCallback();
        }

    };

    CONFUSEDWEBSITE.getUrlVars = function () {
        var vars = [], hash;
        var hashes = ctx.location.href.slice(ctx.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    };

    CONFUSEDWEBSITE.setupSearchResults = function () {
        $('.js-searchResultsConfiguration').each(function (index, element) {
            /* element.dataset here has the properties from data-attributes, so we expect an element with this class to look like the below: - 
                data-custom-search-key="<key>"
                data-results-set-size="10"
                data-no-results-h2-selector=".js-noResultsH2"
                data-results-h2-selector=".js-resultsH2"
                data-results-selector="#cse"    
                data-query-parameter="query" <typically>
                */
            CONFUSEDWEBSITE.setupSearchResult(element.dataset);
        });
    };

    CONFUSEDWEBSITE.setupSearchForms = function () {
    $('.js-searchFormConfiguration').each(function (index, element) {
            /* element.dataset here has the properties from data-attributes, so we expect an element with this class to look like the below: - 
                data-search-form-id="<key>"
                data-button-class="contextual-search__submit--searchContact"
                data-search-text-id="search-contact-search"
                data-custom-search-key-id="query" 
                */
            CONFUSEDWEBSITE.setupSearch(element.dataset);
        });
    };

})(window.jQuery, window, window.google);